import React, { Dispatch, SetStateAction } from "react";
import { SheetForm, TgkAmountObjectSource } from "../../interfaces/CoObject";
import { ObjectPanelTabs } from "../co-panel/ObjectPanelComponent";
import { FileDropDown } from "../FileDropDown";
import { DropDownSheet } from "../co-dropdown-panel/drop-down-sheet/DropDownSheet";
import { ChoiceGroup } from "@fluentui/react";

import ImportAmountAreaSelectionField from "./import-amount/ImportAmountAreaSelectionField";
import { InputAreaSelectionEnum } from "../../../utils/constants/InputAreaSelectionEnum";
import { isNullOrEmptyString } from "@progress/kendo-data-query/dist/npm/utils";
import useExcelAmountSourcePanel from "./ExcelAmountSourcePanelHook";

export interface ExcelComponentProps {
  isEdit?: boolean;
  objectSource: TgkAmountObjectSource;
  updateCoObjectSourceAmount: (obj: TgkAmountObjectSource, tabValid, modified: boolean) => void;
  validateSource: (obj: TgkAmountObjectSource) => ObjectPanelTabs;
  isFileExcelExisting?: boolean;
  fileExcelName?: string;
  updateFileExcelName?: (fileExcelName: string) => void;
  isComponentInstance?: boolean;
  isLocked?: boolean;
  originalSheetArea?: SheetForm;
  setOriginalSheetArea?: Dispatch<SetStateAction<SheetForm>>;
  setIsOldSheetOrAreaSelected?: Dispatch<SetStateAction<boolean>>;
  setIsOldValueForAreaToHide?: Dispatch<SetStateAction<boolean>>;
  isOldValueForAreaToHide?: boolean;
  hasSheetToBeSelected?: boolean;
  setHasSheetToBeSelected?: Dispatch<SetStateAction<boolean>>;
  isLoadingDataExcel?: boolean;
  setIsLoadingDataExcel?: Dispatch<SetStateAction<boolean>>;
  setIsLoadingSheetAndArea?: Dispatch<SetStateAction<boolean>>;
  setIsSheetChartAndAreaToHide?: Dispatch<SetStateAction<boolean>>;
  isSheetChartAndAreaToHide?: boolean;
  objectSourceImage?: string;
}

export const ExcelAmountSourcePanel = (props: ExcelComponentProps) => {
  const {
    objectSource,
    onFileClick,
    selectSheetComboBox,
    initAreas,
    sheetsAreaChartMap,
    selectedAreaOption,
    areaOptions,
    changeAreaSelection,
    selectAreaComboBox,
    selectAmountFromExcelCell,
    isFileExcelExisting,
    fileExcelName,
    updateFileExcelName,
    isComponentInstance,
    isLocked,
    setIsOldValueForAreaToHide,
    isOldValueForAreaToHide,
    hasSheetToBeSelected,
    setHasSheetToBeSelected,
    isLoadingDataExcel,
    setIsLoadingDataExcel,
  } = useExcelAmountSourcePanel(props);

  return (
    <div>
      <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
        <FileDropDown
          form={objectSource.form}
          onFileClick={onFileClick}
          objectSource={objectSource.objectSource}
          isFileExcelExisting={isFileExcelExisting}
          fileExcelName={fileExcelName}
          updateFileExcelName={updateFileExcelName}
          isComponentInstance={isComponentInstance}
          isLocked={isLocked}
        />
      </div>

      <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
        <DropDownSheet
          isEdit={props.isEdit}
          sheet={objectSource.sheet}
          form={objectSource.form}
          dbApplication={objectSource.dbApplication}
          selectSheetComboBox={selectSheetComboBox}
          initAreas={initAreas}
          type={"AMOUNT"}
          objectSource={objectSource.objectSource}
          sheetsAreaChartMap={sheetsAreaChartMap}
          isFileExcelExisting={isFileExcelExisting}
          isComponentInstance={isComponentInstance}
          isLocked={isLocked}
          originalSheetArea={props.originalSheetArea}
          setOriginalSheetArea={props.setOriginalSheetArea}
          setIsOldSheetOrAreaSelected={props.setIsOldSheetOrAreaSelected}
          setIsOldValueForAreaToHide={setIsOldValueForAreaToHide}
          setHasSheetToBeSelected={setHasSheetToBeSelected}
          isLoadingDataExcel={isLoadingDataExcel}
          setIsLoadingDataExcel={setIsLoadingDataExcel}
          setIsLoadingSheetAndArea={props.setIsLoadingSheetAndArea}
          setIsSheetChartAndAreaToHide={props.setIsSheetChartAndAreaToHide}
          isSheetChartAndAreaToHide={props.isSheetChartAndAreaToHide}
        />
      </div>

      <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
        <ChoiceGroup
          selectedKey={selectedAreaOption}
          disabled={
            objectSource.sheet == null ||
            !isFileExcelExisting ||
            isComponentInstance ||
            isLocked ||
            (props.isEdit && objectSource.sheet?.code === objectSource.sheet?.desc && hasSheetToBeSelected)
          }
          styles={{
            flexContainer: { display: "flex", justifyContent: "left", columnGap: "0.5rem", flexWrap: "wrap" },
          }}
          options={areaOptions}
          onChange={changeAreaSelection}
        />
      </div>

      <ImportAmountAreaSelectionField
        isEdit={props.isEdit}
        area={isNullOrEmptyString(objectSource.cell) ? objectSource.area : objectSource.cell}
        sheet={objectSource.sheet}
        sheetsAreaChartMap={sheetsAreaChartMap}
        selectAreaComboBox={selectAreaComboBox}
        selectAmountFromExcelCell={selectAmountFromExcelCell}
        selectFromAreaName={selectedAreaOption === InputAreaSelectionEnum.AREA_NAME.description}
        isFileExcelExisting={isFileExcelExisting}
        isComponentInstance={isComponentInstance}
        isLocked={isLocked}
        objectSource={objectSource.objectSource}
        isOldValueForAreaToHide={isOldValueForAreaToHide}
        hasSheetToBeSelected={hasSheetToBeSelected}
        isLoadingDataExcel={isLoadingDataExcel}
        setIsOldSheetOrAreaSelected={props.setIsOldSheetOrAreaSelected}
      />
    </div>
  );
};
